
export default function Hero() {
  return (
    <section className="relative w-full h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="/assets/img/c8c20c2e2808.webp"
        alt="Standard Stretch Tents hero"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/55"></div>
      <div className="relative z-10 text-center w-full px-4">
        <h1 className="text-6xl md:text-7xl font-extrabold text-white mb-5 tracking-tight leading-tight">
          Standard Stretch Tents
        </h1>
        <p className="text-xl md:text-2xl text-white/85 mb-10 font-light">
          The right size for every occasion
        </p>
      </div>
    </section>
  );
}
